import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../../components/HeaderFFF'
import Header from '../../../components/Header'
import Footer from "../../../components/Footer";
import { Link } from 'react-router-dom';
import '../../../styles/injury.css'

export default function Motorcycle() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="injury">
            <div id="fields-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Motorcycle Accidents</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
            <div className="pi-text">
                <p>If you’ve been involved in a motorcycle accident, the aftermath can be overwhelming. At CLV,
we understand the physical, emotional, and financial toll a motorcycle accident can take on you
and your family. Our Team is dedicated to fighting for the justice and compensation you deserve
for your injuries.<br/><br/>
Motorcycle accidents are a common cause of devastating personal injuries. Not only are
motorcycles more prone to accidents, but motorcyclists have a higher risk of sustaining
disabling injuries and trauma. Even when all the proper safety precautions are taken—including
wearing proper protective gear—a motorcycle accident typically results in much more severe
injuries.<br/><br/>
<span className="pi-sub-section">Causes of Motorcycle Accidents</span><br/><br/>
Motorcyclists are exposed and vulnerable, and when a motorcycle is in a collision with a car,
there’s no doubt about which vehicle occupant typically comes out the worse for wear. It is
crucial that you take preventative measures when riding a motorcycle. It is also crucial that,
when an motorcycle/bike accident does occur, you protect your rights and seek the
compensation you deserve.<br/><br/>

<span className="pi-sub-section">Motorcycle/Bike Accidents Caused by Cars</span><br/><br/>
It is not uncommon for car drivers to fail to see motorcyclists on the road or to take the
necessary precautions when driving around them. The personal injuries that occur from this
negligence can often cause lifelong disabilities, brain injury, and death. Many drivers carelessly
open their car doors without checking for motorcyclists, while other drivers will turn into
motorcyclists by accident.<br/>
When a motorcycle accident does occur, you are likely dealing with devastating personal
injuries. However, it is crucial that you contact a personal injury lawyer before you lose the
right to seek your compensation. There is a limit on how long you can wait to
seek compensation from a liable party or to claim benefits from your motorcycle
accident insurance provider in Ontario.<br/><br/>
<span className="pi-sub-section">We Help to Get the Following Motorcycle Accident Compensation for You</span><br/><br/>
<b>CLV</b> is an experienced personal injury team that can handle motorcycle accident compensation
claims, ensuring that our clients receive the compensation and benefits they are entitled to.
When an insurer denies coverage or a claim, a motorcycle accident lawyer in Toronto can be
the difference between receiving entitlements and having to pay for medical expenses out of
pocket.<br/><br/>
Motorcycle accidents often cause severe and debilitating injuries that can have a major impact
on a person’s health, future earning potential, and day-to-day life. A motorcycle accident
personal injury claim can help cover medical expenses, loss of income, and other associated
costs that accrue as a result of an accident.<br/><br/>
If an individual has suffered from a motorcycle accident in Ontario, CLV can ensure they receive
the compensation they are entitled to. We work with our clients to provide expert legal
representation that will get them the maximum payout and compensation that will help with their
recovery.<br/><br/>
On behalf of our clients, we can file claims for the following injuries (and more) against insurers
and negligent parties:
<ul>
<li>Traumatic brain injuries</li>
<li> Spinal cord injuries</li>
<li>Loss of limb/amputation</li>
<li> Paralysis</li>
<li>Road rash</li>
<li> Head injuries</li>
</ul>
We can seek claims against insurers, pursuing compensation for the following:
<ul>
<li>Pain and suffering</li>
<li>Medical expenses</li>
<li> Loss of income</li>
<li>Home health-care expenses</li>
<li>Home maintenance services</li>
<li>Loss of enjoyment of life</li>
</ul>
<span className="pi-sub-section">Motorcycle Accident</span><br/><br/>
After a motorcycle accident, your focus should be on getting better. Let our focus be on seeking
the compensation you deserve. We at CLV are equipped to handle complex legal and insurance
issues arising from.<br/><br/>

To arrange a Free consultation, <Link to="/contact-us">contact us</Link> today.</p>
            </div>
            <div className="pi-go-back">
                        <Link to="/fields-of-expertise/personal-injury">Take me back</Link>
            </div>
        </div>
            <Footer />
        </>
        );
}